(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["CS-brand-section"] && !window.DesignMode) return;
  try {
    
      jQuery(document).ready(function() {
      $('.owl-carousel').owlCarousel({
    loop:true,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:4
        },
        1000:{
            items:5
        }
    }
})

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CS-collection"] && !window.DesignMode) return;
  try {
    
      jQuery(document).ready(function() {
      $('.owl-carousel').owlCarousel({
    loop:false,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2  
        }, 
        1000:{
            items:3
        } 
    }
})

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CS-popup"] && !window.DesignMode) return;
  try {
    	

jQuery(document).ready(function(){
  jQuery('.popup-close-btn').click(function(){
      jQuery('.popup-main').hide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

jQuery(document).ready(function(){
  jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change'); 
  });
});
jQuery('.size-btn').find('label').first().addClass('active');
  jQuery('.size-btn label').click(function(){
	jQuery('.size-btn label').removeClass('active');
	jQuery(this).addClass('active');
  }); 

 jQuery('.color-btn').find('label').first().addClass('active');
  jQuery('.color-btn label').click(function(){
	jQuery('.color-btn label').removeClass('active');
	jQuery(this).addClass('active');
  }); 
            
		jQuery("#rmove").click(function() {
    jQuery('html, body').animate({
        scrollTop: (jQuery("#reviewsforproducts").offset().top-50)
    }, 2000);
});

$('.owl-carousel').owlCarousel({
    loop:false,
    nav:true,
    responsive:{
        0:{
            items:2   
        },
        600:{
            items:2 
        },
        1000:{
            items:4
        }
    }
})

});


  } catch(e) { console.error(e); }
})();

})();
